import React, { Fragment } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useRef } from "react";
import { useLocation } from "react-router-dom/dist";
import {
  useClientUpdateById,
  useCreateClient,
  useGetClientById,
} from "../../actions/client-actions";
import { useState } from "react";
import { useEffect } from "react";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TostifyConfig } from "../../utils/Constance";
import LoadingOverlay from 'react-loading-overlay';

function AddClient() {
  const navigate = useNavigate();

  const FormRef = useRef(null);
  const location = useLocation();

  let id = location?.state?.rowId;

  const { mutate: postNewClient, isLoading: loadingPostClientFn } =
    useCreateClient();
  const { mutate: patchClientInfo, isLoading: loadingPatchClientFn } =
    useClientUpdateById();

  const [clientData, setClientData] = useState({
    contact_address: "",
    client_name: "",
    contact_mail: "",
    contact_manager: "",
    client_short_name: "",
    contact_phone_number: "",
  });

  const handleChange = (e) => {
    setClientData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSubmit = () => {
    let FormValidity = FormRef.current.reportValidity();
    if (FormValidity === true && location?.state?.rowId) {

      try {
        patchClientInfo(
          { id, clientData },
          {
            onSuccess: (response) => {
              toast.success("Client Profile Updated", TostifyConfig);
              navigate("/list-client/");
            },
          }
        );
      } catch (error) {
        console.error(error);
      }
    } else if (FormValidity === true) {
      try {
        postNewClient(clientData, {
          onSuccess: (response) => {
            toast.success("Client Profile Added", TostifyConfig);
            navigate("/list-client/");
          },
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const { data: clientDetailsById, isLoading: loadingClientFn } = useGetClientById(
    location?.state?.rowId
  );

  useEffect(() => {
    if (location?.state?.rowId) {
      setClientData(clientDetailsById);
    }
  }, [clientDetailsById]);
  return (
    <Fragment>
      <PageTitle
        activeMenu={id ? "Edit Client" : "Add Client"}
        motherMenu="Settings"
      />
      <div>
        <div className="col-xl-12 col-xxl-12">
          <Card className="az-card">
            <Card.Header>
              <h3>{id ? "Edit Client" : "New Client"}</h3>
            </Card.Header>
            <LoadingOverlay
              active={loadingClientFn && id}
              spinner
              text='Fetching...'
              className="custom-overlay"
            >
              <Card.Body>
                <form ref={FormRef}>
                  <Form.Group className="mb-3">
                    <Row>
                      <Col className="col-lg-6 mb-2">
                        <label>Client Name <span className="required">*</span></label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="client_name"
                          value={clientData?.client_name}
                          onChange={(e) => handleChange(e)}
                          required
                        />
                      </Col>
                      <Col className="col-md-6 mb-2">
                        <label>Short Name <span className="required">*</span></label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="client_short_name"
                          value={clientData?.client_short_name}
                          onChange={(e) => handleChange(e)}
                          required
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Row>
                      <Col className="col-md-6 mb-2">
                        <label>Email <span className="required">*</span></label>
                        <Form.Control
                          type="email"
                          placeholder="Type Text"
                          name="contact_mail"
                          value={clientData?.contact_mail}
                          onChange={(e) => handleChange(e)}
                          required
                        />
                      </Col>

                      <Col className="col-md-6 mb-2">
                        <label>Phone Number</label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="contact_phone_number"
                          value={clientData?.contact_phone_number}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Row>
                      <Col className="col-md-6 mb-2">
                        <label>Manager Name</label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="contact_manager"
                          value={clientData?.contact_manager}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col className="col-md-6 mb-2">
                        <label>Address</label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="contact_address"
                          value={clientData?.contact_address}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group className="mt-2">
                    <Row>
                      <Col className="col-md-12">
                        <hr />
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Button
                            variant="danger light btn-sm"
                            onClick={() => {
                              navigate("/list-client");
                            }}
                          >
                            Cancel
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            variant="primary btn-sm"
                            onClick={handleSubmit}
                            disabled={loadingClientFn && id || loadingPostClientFn || loadingPatchClientFn}
                          >
                            {loadingPostClientFn || loadingPatchClientFn ? (
                              <>
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  className="me-2"
                                />
                                Loading...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>
                </form>
              </Card.Body>
            </LoadingOverlay>
          </Card>
        </div>
      </div>
    </Fragment>
  );
}

export default AddClient;
